import axios from '../request/http';
import commentApi from './robot/comment';

const baseRobotApi = {
  getRobotConfigList(params) {
    return axios.get('/hemei-admin/robot/getRobotConfigList', { params });
  },
  addRobotConfig(data) {
    return axios.post('/hemei-admin/robot/addRobotConfig', data);
  },
  updateRobotConfig(data) {
    return axios.post('/hemei-admin/robot/updateRobotConfig', data);
  },
  delRobotConfig(params) {
    return axios.get('/hemei-admin/robot/delRobotConfig', { params });
  },
  setDefaultRobotConfig(params) {
    return axios.get('/hemei-admin/robot/setDefaultRobotConfig', { params });
  },
  getVillageByName(params) {
    return axios.get('/service-app/village/getVillageIdByName', { params });
  },
  getUserIdByName(params) {
    return axios.get('/service-user/user/getUserIdByName', { params });
  },
  // 人机互动任务筛选文章列表
  robotGetArticleList(data) {
    return axios.post(
      '/hemei-admin/robot/robotGetArticleList',
      data,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    );
  },
  addRobotTask(data) {
    return axios.post(
      '/hemei-admin/robot/addRobotTask',
      data,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    );
  },
  getRobotTaskList(params = {}) {
    const query = {
      pageNum: params.pageNum || 1,
      pageSize: params.pageSize || 10
    };
    const optionalKeys = ['articleType', 'publisherId', 'status', 'startTime', 'endTime'];
    optionalKeys.forEach((key) => {
      const value = params[key];
      if (value === undefined || value === null || value === '') {
        return;
      }
      if (key === 'articleType' && Number(value) === 0) {
        return;
      }
      if (key === 'status' && Number(value) === -1) {
        return;
      }
      query[key] = value;
    });
    return axios.get('/hemei-admin/robot/getRobotTaskList', { params: query });
  },
  delRobotTask(params) {
    return axios.get('/hemei-admin/robot/delRobotTask', { params });
  },
  getRobotCommentTaskList(params = {}) {
    const query = {
      pageNum: params.pageNum || 1,
      pageSize: params.pageSize || 20
    };
    const optionalKeys = ['articleType', 'publisherId', 'status', 'startTime', 'endTime'];
    optionalKeys.forEach((key) => {
      const value = params[key];
      if (value === undefined || value === null || value === '') {
        return;
      }
      if (key === 'articleType' && Number(value) === 0) {
        return;
      }
      if (key === 'status' && Number(value) === -1) {
        return;
      }
      query[key] = value;
    });
    return axios.get('/hemei-admin/robot/getRobotCommentTaskList', { params: query });
  },
  addRobotCommentTask(data) {
    return axios.post(
      '/hemei-admin/robot/addRobotCommentTask',
      data,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    );
  },
  delRobotCommentTask(params) {
    return axios.get('/hemei-admin/robot/delRobotCommentTask', { params });
  }
};

export default {
  ...baseRobotApi,
  ...commentApi
};



// WEBPACK FOOTER //
// ./src/api/robot.js